import {getAllsettings} from "@/api/commonApi";


const state = {
    title: "2025年中国大学生机械工程创新创意大赛",// 标题
    logo:"https://cdn.brightstonecloud.com/competition/doc/login-bg (2)_1740552468.png", // logo
    can_register:true, // 是否可注册
    can_submit:true, // 是否可提交
    register_start:"", // 注册开始时间
    register_end:"", // 注册结束时间
    upload_end:"", // 作品截止提交时间
    final_file_upload_start:"", // 复赛文件提交开始时间
    final_file_upload_end:"", // 复赛文件提交结束时间
}

const mutations = {
    updateInfo: (state, payload) => {
    state[payload.key] = payload.value
},



}
const actions = {
    async  getAllsettingsFun(context,data){
        const res = await getAllsettings(data)
        if(res.success){
            if(res.time){
                context.commit("updateInfo",{key:"can_register",value:res.time.can_register})// 更新用户信息
                context.commit("updateInfo",{key:"can_submit",value:res.time.can_submit})// 更新权限
            }
            if(res.data){
              res.data.forEach(item=>{
                  if(item.KeyName==="name"){
                      context.commit("updateInfo",{key:"title",value:item.Value})// 更新用户信息
                  }else{
                      context.commit("updateInfo",{key:item.KeyName,value:item.Value})// 更新权限
                  }
              })
            }

        }
        return Promise.resolve(res)
    }

}
const modules = {}
export default {
    namespaced: true,
    state() {
        return state
    },
    mutations,
    actions,
    modules
}

